import { z } from "zod";

export const siteConstraintsSummaryDtoSchema = z.object({
  hasDefinitiveDeactivation: z.boolean(),
  hasLinkDeactivation: z.boolean(),
  hasModulationLimitation: z.boolean(),
  hasPlanning: z.boolean(),
  hasTemporaryDeactivation: z.boolean(),
});

export type TSiteConstraintsSummaryDto = z.infer<typeof siteConstraintsSummaryDtoSchema>;
